import { render, staticRenderFns } from "./VipServices.vue?vue&type=template&id=5ab0b023&scoped=true&"
import script from "./VipServices.vue?vue&type=script&lang=js&"
export * from "./VipServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab0b023",
  null
  
)

export default component.exports